<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TMapMarkerDisplay',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('ins')" ref="mapRef" :style="{ height }" />
    <div :class="bem('ft')">
      <div v-if="value" @click="handleZoomToCenter"><span>经纬度：</span>{{ value }}</div>
      <span v-else>暂无位置信息</span>
    </div>
  </div>
</template>

<script lang="ts" setup name="TMapMarkerDisplay">
import { onMounted, ref, nextTick, watch } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { RS_CENTER_LNG_LAT } from '@/constant'
import { decodeLngLat } from '../utils'
import { useTMapBase } from '../useTMapBase'
import { useTMapMarker } from '../useTMapMarker'

const [_, bem] = createNamespace('TMapMarkerDisplay')

/** 组件属性 */
const props = withDefaults(
  defineProps<{
    /** 地图高度 */
    height?: string
    /** 经纬度值（格式：lng,lat） */
    value?: string
  }>(),
  {
    height: '400px'
  }
)

const mapRef = ref<HTMLElement>()

// 使用基础地图 Hook
const { Map, initMap } = useTMapBase(mapRef, {
  center: RS_CENTER_LNG_LAT
})

// 使用标记点管理 Hook
const { addMarker, centerToPoint } = useTMapMarker(Map)

/**
 * 初始化标记点显示
 * 根据传入的value回显标记
 */
const initMarkerDisplay = () => {
  if (props.value) {
    const lnglat = decodeLngLat(props.value)
    if (!lnglat) return
    addMarker(lnglat)
  }
}

/**
 * 点击经纬度信息时，地图居中到标记点
 */
const handleZoomToCenter = () => {
  if (props.value) {
    const lnglat = decodeLngLat(props.value)
    if (!lnglat) return
    centerToPoint(lnglat)
  }
}

// 监听 value 变化，回显标记点
watch(
  () => props.value,
  val => {
    if (Map.value && val) {
      const lnglat = decodeLngLat(val)
      if (!lnglat) return
      addMarker(lnglat)
    }
  }
)

onMounted(() => {
  nextTick(() => {
    const mapIns = initMap()
    if (mapIns) {
      // 初始化标记点回显
      initMarkerDisplay()
    }
  })
})
</script>

<style lang="less">
@import '../index.less';

.t-map-marker-display {
  .map-box();

  &__ft {
    .map-box-ft-gray();
  }
}
</style>
